import React from 'react'
import { IoMdSend } from 'react-icons/io';


const Input = ({messageInput,sendMessage,setMessage,message}) => {
    return (
        <footer className="fixed bottom-0 left-0 w-full bg-blue-100 py-2">
        <div className="flex items-center m-2 ">
        <input ref={messageInput} className="rounded-full border-b-2 px-5 py-2 bg-white  w-full focus:outline-none " type="text" value={message} 
        placeholder="Type a message"
        onChange={(event) => setMessage(event.target.value)} 
        onKeyPress={(event)=> event.key === 'Enter' ? sendMessage(event):null} />

        <button className="mx-2 bg-blue-600 flex justify-center items-center rounded-full p-2 text-white font font-semibold uppercase focus:outline-none" onClick={(event)=> sendMessage(event)}>
          <IoMdSend size="20" ></IoMdSend>
        </button>
      </div>
      </footer>
    )
}

export default Input
